import { createContext, useContext } from 'react'

export const SETTINGS_CONTEXT_DEFAULT = {
  versionImages: 0,
  nodeChartsDomain: '',
  hasUserPremium: false,
  name: '',
  email: '',
  hasDarkTheme: false,
  hasEliteRedesign: false,
  hasRedesignPortfolio: false,
}

export const SettingsContext = createContext<typeof FinvizSettings>(SETTINGS_CONTEXT_DEFAULT)

export function useSettings() {
  return useContext(SettingsContext)
}
